
import ClickOutside from 'vue-click-outside';

export default {
  name: 'Modal',
  mixins: [],
  props: {
    title: {
      type: String,
      require: false,
    },
    showOverflow: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      isModalVisible: false,
    };
  },
  computed: {
    modalClasses() {
      return {
        'modal': true,
        'overflow-auto': this.showOverflow,
        'no-overflow': !this.showOverflow,
      };
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.isModalVisible = true;
    });
    this.popupItem = this.$el;
  },
  directives: {
    ClickOutside,
  },
  methods: {
    modalWrapperClickHandler(event) {
      //close a modal on wrapper empty space click
      if (event.target.classList.contains("modal-overlay")) {
        this.$emit('close-modal');
      }
    },
  },
};
